import MainNav, { selector as MainNavSelector } from './nav/script';
import Footer, { selector as FooterSelector } from './footer/script';
import Locations, { selector as LocationsSelector } from './locations/script';
import Overview, { selector as OverviewSelector } from './overview/script';

export default {
	[MainNavSelector]: { Class: MainNav },
	[FooterSelector]: { Class: Footer },
	[LocationsSelector]: { Class: Locations },
	[OverviewSelector]: { Class: Overview }
};
